import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Section } from 'src/app/core/models/DigitalKit';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.css'],
  standalone: false
})
export class OnboardingComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Onboarding Digital');
  }

  cards: Section[] = [
    {
      title: 'WEB ADAPTADA',
      description: 'Proporcionamos una web con todo el servicio de OBD a tu negocio.',
      icon: 'assets/img/obd-card-1.png'
    },
    {
      title: 'PERSONALIZACIÓN',
      description: 'Adoptamos el look and feel al branding de tu empresa.',
      icon: 'assets/img/obd-card-2.png'
    },
    {
      title: 'FIRMA DIGITAL',
      description: 'OBD se ajusta a ambas soluciones: Firma digital avanzada y cualificada.',
      icon: 'assets/img/obd-card-3.png'
    },
    {
      title: 'BASE DE DATOS',
      description: 'Obtendrás toda la información recabada en una base de datos.',
      icon: 'assets/img/obd-card-4.png'
    }
  ];

  advantages: Section[] = [
    {
      title: 'SEGURIDAD',
      description: 'Información comprobada al instante, otorgando más fiabilidad',
      icon: 'assets/img/obd-why-1.png'
    },
    {
      title: 'RAPIDEZ',
      description: 'Tanto a la hora de comprobar la información, como a la hora de realizar el formulario para el usuario',
      icon: 'assets/img/obd-why-2.png'
    },
    {
      title: 'MODULABLE',
      description: 'Libertad de decisión a la hora de decidir los pasos a seguir',
      icon: 'assets/img/obd-why-3.png'
    },
    {
      title: 'ECONÓMICO',
      description: 'Aumento del ahorro en el coste del personal',
      icon: 'assets/img/obd-why-4.png'
    },
    {
      title: 'OPTIMIZACIÓN DE LEAD',
      description: 'Aumento de la cantidad y la calidad de los leads, debido a la comprobación de la información',
      icon: 'assets/img/obd-why-5.png'
    },
    {
      title: 'INTEGRACIÓN A MEDIDA',
      description: 'Capacidad de integración en cualquier proceso, ya sea web, web app o app',
      icon: 'assets/img/obd-why-6.png'
    }
  ];


}
